import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../config";

const EmployeeNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));
  const employeeId = user?.employeeId;
  const employeeMongoId = user?._id || null;

  useEffect(() => {
    if (!employeeId) return;
    loadNotifications();
  }, [employeeId]);

  const loadNotifications = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/notifications/employee/${employeeId}`);
      const all = res.data.notifications || [];
      const isTaskAssignment = (n) =>
        String(n?.title || "").trim().toLowerCase() === "new task assigned" ||
        String(n?.body || "").toLowerCase().includes("you have been assigned a new task");
      setNotifications(all.filter((n) => isTaskAssignment(n)));
    } catch (err) {
      console.error("Load notifications error:", err);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.put(`${API_URL}/api/notifications/read/${id}`, {
        employeeId: employeeMongoId || employeeId,
      });
      setNotifications((prev) =>
        prev.map((n) => (n._id === id ? { ...n, isRead: true } : n))
      );
    } catch (err) {
      console.error("Mark as read error:", err);
    }
  };

  return (
    <div>
      <h2 className="emp-page-title">Notifications</h2>
      <p className="emp-page-subtitle">Stay updated with alerts from admin and task workflows.</p>

      <section className="emp-panel">
        <div className="emp-panel-body">
          {loading ? (
            <p className="mb-0">Loading notifications...</p>
          ) : notifications.length === 0 ? (
            <div className="text-center py-4 text-muted">You have no new notifications.</div>
          ) : (
            <div className="d-flex flex-column gap-3">
              {notifications.map((n) => (
                <div
                  key={n._id}
                  className="p-3 rounded-3 border"
                  style={{
                    background: n.isRead ? "#f8fafc" : "#eff6ff",
                    borderColor: "#dbeafe",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start gap-3">
                    <div>
                      <h6 className="mb-1">{n.title}</h6>
                      <p className="mb-0 text-muted">{n.body}</p>
                    </div>
                    <small className="text-muted">{new Date(n.createdAt).toLocaleString()}</small>
                  </div>
                  {!n.isRead ? (
                    <div className="mt-2 d-flex align-items-center gap-2">
                      <span className="emp-soft-badge info d-inline-block">Unread</span>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => markAsRead(n._id)}
                      >
                        Mark as read
                      </button>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default EmployeeNotifications;
